import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  selectGender(event) {
    this.toggleSelection(event, '.gender-card')
  }

  selectLookingFor(event) {
    this.toggleSelection(event, '.looking-card')
  }

  toggleSelection(event, selector) {
    this.element.querySelectorAll(selector).forEach(card => {
      card.classList.remove('selected')
    })

    event.currentTarget.classList.add('selected')

    const radioButton = event.currentTarget.querySelector('input[type="radio"]')
    if (radioButton) {
      radioButton.checked = true
    }
  }

  connect() {
    this.initializeSelectedState('.gender-card')
    this.initializeSelectedState('.looking-card')
  }

  initializeSelectedState(selector) {
    this.element.querySelectorAll(selector).forEach(card => {
      const radio = card.querySelector('input[type="radio"]')
      if (radio && radio.checked) {
        card.classList.add('selected')
      }
    })
  }
}
